// eslint-disable-next-line
// @ts-ignore
export const publicPath = '/connect';
